import { takeEvery, put, call } from "redux-saga/effects"
import { GET_MEETINGS, ADD_MEETING, UPDATE_MEETING, DELETE_MEETING } from './actionTypes';
import { 
  getMeetingsSuccess, 
  getMeetingsFail,
  addMeetingSuccess,
  addMeetingFail,
  updateMeetingSuccess,
  updateMeetingFail,
  deleteMeetingSuccess,
  deleteMeetingFail,
  showLoading, 
  hideLoading 
} from './actions';
import {
  getMeetingsInfo,
  addMeeting,
  updateMeeting,
  deleteMeeting
} from "../../helpers/backend_helper"
import { showToast } from '../../components/Toast';

function* fetchMeetingsInfo() {
  try {
    yield put(showLoading(true))
    const response = yield call(getMeetingsInfo)
    yield put(getMeetingsSuccess(response))
    yield put(hideLoading(false))
  } catch (error) {
    yield put(showLoading(true))
    yield put(getMeetingsFail(error))
  }
}
function* onAddMeeting({ payload: meeting }) {
  try {
    yield put(showLoading(true))
    const response = yield call(addMeeting, meeting)
    showToast("New Meeting is added")
    yield put(addMeetingSuccess(response))
    yield put(hideLoading(false))
  } catch (error) {
    yield put(showLoading(true))
    yield put(addMeetingFail(error.response))
  }
}
function* onUpdateMeeting({ payload: meeting }) {
  try {
    yield put(showLoading(true))
    const response = yield call(updateMeeting, meeting)
    showToast("Changes Successfully Applied")
    yield put(updateMeetingSuccess(response))
    yield put(hideLoading(false))
  } catch (error) {
    yield put(hideLoading(false))
    yield put(updateMeetingFail(error))
  }
}
function* onDeleteMeeting({ payload: meeting }) {
  try {
    yield put(showLoading(true))
    const response = yield call(deleteMeeting, meeting)
    showToast("Meeting is deleted from the system")
    yield put(deleteMeetingSuccess(response))
    yield put(hideLoading(false))
  } catch (error) {
    yield put(hideLoading(false))
    yield put(deleteMeetingFail(error))
  }
}
function* meetingSaga() {
  yield takeEvery(GET_MEETINGS, fetchMeetingsInfo)
  yield takeEvery(ADD_MEETING, onAddMeeting)
  yield takeEvery(UPDATE_MEETING, onUpdateMeeting)
  yield takeEvery(DELETE_MEETING, onDeleteMeeting)
}

export default meetingSaga;